<template>
  <a-card :bordered="false" :title="name+'>'+codeName">
    <search-page-view
      ref="table"
      :item-names="isElectronicCode?['s1','s3']:['s1','s2','s3']"
      :button-items="['button_operation']"
      :request-promise="getRequestPromise"
      row-key="redeemCode"
      :query-params="queryParams"
      :columns="getCommonColumns()"
      :customPagination="true"
      extraPaginationName="extraPaginationName"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <a-form-item slot="s1" :label="codeName" v-bind="searchItemLayout">
        <a-input placeholder="请输入" v-model="queryParams.redeemCode"></a-input>
      </a-form-item>
      <template v-if="!isElectronicCode">
        <a-form-item slot="s2" label="关联订单号" v-bind="searchItemLayout">
          <a-input placeholder="请输入" v-model="queryParams.orderNo"></a-input>
        </a-form-item>
      </template>
      <a-form-item slot="s3" label="状态" v-bind="searchItemLayout">
        <a-select v-model="queryParams.status" allowClear style="width:100%" placeholder="请选择">
          <a-select-option
            v-for="item in redeemCodeStatusList"
            :key="item.key"
            :value="item.key"
          >{{ item.src }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <div slot="button_operation" style="display: inline-block;">
        <a-popconfirm
          style="margin-left:10px"
          :title="'此操作将批量导出'+ (selectedRowKeys.length>0?'选中':'全部') +'券码, 是否继续？'"
          @confirm="onExportEvent">
          <a-button>导出</a-button>
        </a-popconfirm>
      </div>
      <div class="extra-pagination-name" slot="extraPaginationName" v-if="selectedRowKeys.length > 0">
        <span>已选择 <a>{{ selectedRowKeys.length }}</a> 项</span>
        <a-popconfirm
          style="margin-left:10px"
          title="此操作将批量作废选中券码, 是否继续？"
          @confirm="onDiscardEvent()">
          <a-button type="danger" ghost>作废</a-button>
        </a-popconfirm>
        <a-button style="margin-left:10px" @click="onMergeSend">合并发送</a-button>
      </div>
      <template slot="redeemCode" slot-scope="rowItem">
        <span
          :style="{color: rowItem.record.redeemCode&&rowItem.record.redeemCode.startsWith('bcbz_')?'red':'#444444'}">{{ rowItem.record.redeemCode }}</span>
      </template>
      <template slot="action" slot-scope="rowItem" v-if="rowItem.record.useStatus===0">
        <a v-if="rowItem.record.smsStatus===0" @click="sendEvent(rowItem.record)">发送</a>
        <a v-else-if="rowItem.record.smsStatus===1" @click="sendEvent(rowItem.record)">重新发送</a>
      </template>
    </search-page-view>
    <!--  '发送电子码':'发送预约码'  -->
    <couponSendMessageDialog
      :title="codeName"
      :visible="dialogVisible"
      :loading="submitLoading"
      :sendForm="sendForm"
      @cancel="cancelDialog"
      @submitData="submitEvent"
    >
    </couponSendMessageDialog>
    <a-modal :title="'合并发送'+codeName" :visible="mergeVisible" width="650px" :footer="null"
             @cancel="mergeVisible=false">
      <a-form-model :model="mergeForm" :rules="mergeRules" ref="mergeForm" :label-col="{span:5}"
                    :wrapper-col="{span:19}">
        <a-form-model-item label="手机号码" style="margin-bottom: 0" prop="phone">
          <a-input v-model="mergeForm.phone" auto-complete="off" :maxLength="11" placeholder="请填手机号码"></a-input>
        </a-form-model-item>
        <p class="lhp">*平台抢购类自动填写手机号</p>
        <a-form-model-item label="发送短信" prop="sendFlag" style="margin-bottom: 5px;">
          <a-switch checked-children="是" un-checked-children="否" v-model="mergeForm.sendFlag"/>
        </a-form-model-item>
        <a-form-model-item label="短信内容" prop="smsContent">
          <a-textarea v-model="mergeForm.smsContent" placeholder="请输入短信内容"
                      :auto-size="{ minRows: 3, maxRows: 5 }"/>
        </a-form-model-item>
        <a-form-model-item label="备注信息">
          <a-textarea v-model="mergeForm.remark" :rows="4" :maxLength="100" placeholder="请填写备注信息"></a-textarea>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" :loading="submitLoading" @click="onSubmit">确定</a-button>
          <a-button style="margin-left: 10px;" @click="mergeVisible = false">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import couponSendMessageDialog from '../components/couponSendMessageDialog'

export default {
  name: 'CodeDetailList',
  mixins: [searchForm],
  components: {
    couponSendMessageDialog
  },
  data() {
    return {
      queryParams: {},
      selectedRowKeys: [],
      selectedRows: [],
      requestPath: '',
      id: '',
      type: '',
      name: '',
      isElectronicCode: false,//电子码为true; 通用券码为false(含激活码)
      dialogVisible: false,
      codeName: '',
      sendForm: {
        phone: '',
        message: '',
        orderNo: '',
        smsContent: '',
        redeemCode: '',
        sendFlag: true
      },
      mergeForm: {
        smsContent: '',
        sendFlag: true
      },
      mergeRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号！', trigger: 'blur' }
        ],
        smsContent: [
          { required: true, message: '请输入短信内容', trigger: 'blur' }
        ]
      },
      submitLoading: false,
      redeemCodeStatusList: [],
      mergeVisible: false,
      couponInfoList: []
    }
  },

  created() {
    this.getRedeemCodeStatusData()
    const pageParams = this.getPageParams()
    this.id = pageParams.id
    this.queryParams.couponSetId = pageParams.id
    this.type = pageParams.type
    this.name = pageParams.name
    this.isElectronicCode = this.type === 'DZM'
    let codeName = ''
    if (this.type == 'DZM') {
      codeName = '电子码'
    } else if (this.type == 'DHQ') {
      codeName = '预约码'
    } else {
      codeName = '激活码'
    }
    this.codeName = codeName
    console.error('this.codeName', this.codeName)
  },
  mounted() {
  },
  methods: {
    onSubmit() {
      this.$refs['mergeForm'].validate(valid => {
        if (valid) {
          let item = {
            orderNo: this.couponInfoList[0].orderNo,
            message: this.mergeForm.remark,
            phone: this.mergeForm.phone,
            smsContent: this.mergeForm.smsContent,
            sendFlag: this.mergeForm.sendFlag
          }
          this.sendRequest(item, 2)
        }
      })
    },
    getRequestPromise(params) {
      return this.getHttpServices().getCouponService().post('couponSetInfo/selectCouponRedeemTrade', params)
    },
    onMergeSend() {
      if (this.selectedRowKeys.length > 0) {
        let firstOrderCode = this.selectionRows[0].orderCode
        let flag = true
        if (firstOrderCode) {
          this.selectionRows.forEach((item, index) => {
            if (firstOrderCode == item.orderCode) {
              flag = true
            } else {
              flag = false
            }
          })
          if (flag) {
            let arrNew = this.couponInfoList.map(item => item.redeemCode)
            let orderNo = firstOrderCode ? firstOrderCode : ''
            this.getSendSmsDetail(this.id, arrNew, orderNo, 2)
          } else {
            this.$message.error('仅支持关联订单号相同的' + this.codeName + '合并发送')
          }
        } else {
          let arrNew = this.couponInfoList.map(item => item.redeemCode)
          let orderNo = ''
          this.getSendSmsDetail(this.id, arrNew, orderNo, 2)
        }
      } else {
        this.$message.error('请选择勾选项')
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      if (selectedRowKeys.length === selectedRows.length) {
        this.selectionRows = selectedRows
      } else {
        this.selectionRows = selectedRowKeys.map(key => (
          this.selectionRows.find(row => row.redeemCode === key) || selectedRows.find(row => row.redeemCode === key)//必在两者之中
        ))
      }
      let arr = []
      this.selectionRows.forEach(function(item, index) {
        arr.push({ couponId: item.couponId, redeemCode: item.redeemCode, orderNo: item.orderCode })
      })
      this.couponInfoList = arr
      this.getLogUtils().logWithTag('couponInfoList', this.couponInfoList)
    },
    getRedeemCodeStatusData() {
      this.getHttpServices().getCouponService().post('couponSetInfo/redeemCodeStatusData').then(list => {
        this.redeemCodeStatusList = list
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getCommonColumns() {
      return [
        {
          title: this.codeName,
          dataIndex: 'redeemCode',
          scopedSlots: { customRender: 'redeemCode' }
        },
        {
          title: '关联订单',
          dataIndex: 'orderCode'
        },
        {
          title: '券码来源',
          dataIndex: 'sourceStr'
        },
        {
          title: '派发方式',
          dataIndex: 'distributeWayStr'
        },
        {
          title: '当前状态',
          dataIndex: 'status'
        },
        {
          title: '核销人',
          dataIndex: 'verificationName'
        },
        {
          title: '核销时间',
          dataIndex: 'verificationTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },

    onDiscardEvent() {
      if (this.selectedRowKeys.length < 1) {
        return this.$message.error('请选择预约选项')
      }
      const params = {
        codeList: this.selectedRowKeys,
        status: 3
      }
      this.updateCodeStatus(params, '作废成功')
    },
    onExportEvent() {
      let couponListStr = ''
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        couponListStr = this.selectedRowKeys.join(',')
      }
      const url = this.getAppConfig().conponUrl + 'couponSetInfo/CouponExportExcel' + '?couponId=' + this.id + '&redeemCodes=' + couponListStr
      window.open(url)
    },
    //发送
    sendEvent(record) {
      this.sendForm.phone = record.phone
      this.sendForm.orderNo = record.orderCode ? record.orderCode : ''
      this.sendForm.redeemCode = record.redeemCode
      this.sendForm.couponId = record.couponId
      this.getSendSmsDetail(record.couponId, [record.redeemCode], this.sendForm.orderNo, 1)
    },
    cancelDialog() {
      this.dialogVisible = false
    },
    submitEvent(record) {
      this.getLogUtils().logWithTag('===submitEvent====', record)
      this.sendRequest(record, 1)
    },
    getSendSmsDetail(couponId, redeemCodeList, orderNo, type) {
      let params = {
        couponId: couponId,
        orderNo: orderNo,
        redeemCodeList: redeemCodeList
      }
      this.getHttpServices().getCouponService().post('couponSetInfo/getCouponCodeSms', params)
        .then(res => {
          if (type == 1) {
            this.sendForm.smsContent = res
            this.dialogVisible = true
            this.sendForm.sendFlag = true
          } else {
            this.mergeForm.smsContent = res
            this.sendForm.sendFlag = true
            this.mergeVisible = true
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //更新券码状态
    updateCodeStatus(params, tips) {
      this.operationPostRequest('couponSetInfo/updateStatus', params, tips)
    },
    sendRequest(item, type) {
      let arrNew = []
      if (type == 2 && this.couponInfoList && this.couponInfoList.length > 0) {
        arrNew = this.couponInfoList.map(obj => {
          return obj.redeemCode
        })
      }
      this.submitLoading = true
      let params = {
        couponId: this.id,
        message: item.message,
        phone: item.phone,
        orderNo: item.orderNo,
        smsContent: item.smsContent,
        redeemCodeList: type == 1 ? [item.redeemCode] : arrNew,
        sendFlag: item.sendFlag
      }
      this.getHttpServices().getCouponService().post('couponSetInfo/sendCouponCodeSms', params)
        .then(res => {
          this.dialogVisible = false
          this.mergeVisible = false
          this.$message.success('成功发送')
          this.$refs.table.refresh(true)
          this.selectedRows = []
          this.selectedRowKeys = []
          this.couponInfoList = []
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //操作请求
    operationPostRequest(path, params, tips) {
      this.getHttpServices().getCouponService().post(path, params)
        .then(res => {
          this.$message.success(tips)
          this.$refs.table.refresh(false)
          this.selectedRows = []
          this.selectedRowKeys = []
          this.couponInfoList = []
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style scoped>
.lhp {
  height: 30px;
  line-height: 30px;
  padding-left: 124px;
  margin-bottom: 0;
}
</style>